/**
 * Подписывается на публичный канал новых статей, обновляет счетчик новых статей в шапке
 */

import { blinkTitle } from "../../../helpers/update-title";

const updatePostMarkers = () => {
  let postMarkers = Array.from(document.querySelectorAll("[data-new-post-marker]"));
  postMarkers.forEach(marker => marker.classList.add('has-new'));
}

const subscriber = (rt) => {
  rt.subscribePublic("wall", data => {
    if (data.newPost) { 
      updatePostMarkers(); 
      blinkTitle("Новая публикация");
    }
  });
};

export default subscriber;